/**
 * Quiz bundle entry (build/js/em-quiz.js). Standalone: no jQuery, no theme
 * imports and no dynamic imports (webpack's publicPath is theme-specific).
 *
 * window.emQuiz.scan() initializes quizzes added to the page later.
 *
 * @package ppd
 * @since   1.0.27
 */

import Quiz from './em-quiz/quiz';
import { initModals } from './em-quiz/modal';

function init(root) {
	if (!root || root.emQuiz) {
		return root ? root.emQuiz : null;
	}
	try {
		root.emQuiz = new Quiz(root, JSON.parse(root.dataset.emQuizConfig));
	} catch (error) {
		console.error('[em-quiz] Could not start quiz', error);
		return null;
	}
	return root.emQuiz;
}

function scan(context = document) {
	context.querySelectorAll('[data-em-quiz]').forEach(init);
}

// Popups (em-components plugin) load this bundle again for a quiz they show
// (em_quiz_detached_asset_tags()), so it only sets up once.
if (window.emQuiz) {
	window.emQuiz.scan();
} else {
	window.emQuiz = { init, scan };
	initModals();
	scan();

	// The popups plugin inserts its popups after load.
	window.addEventListener('emPopupReady', () => scan());
}
